<div class="citation-details">
  <div class="citation-details__list">
    <div class="citation-details__list-item" *ngFor="let detail of details">
      <div class="citation-details__list-item-label">{{detail.title}}</div>
      <div class="citation-details__elements" *ngFor="let item of detail.data">
        <div>{{item.title}}</div><div>{{item.count}}</div>
      </div>
      <div class="citation-details__elements" *ngIf="!detail?.data?.length">
        <div>-</div>
      </div>
    </div>
  </div>
</div>
